import React from "react";
import TextInfo from "@/bit/components/next13.components.text";
import IconGlyph from "@/bit/components/next13.components.icon-glyph"

const CharacteristicItems = (props) => {
    const characKeys = Object.keys(props).filter((key) =>
        /^Charac-\d+$/.test(key)
    );
    const characValues = characKeys.map((key) => props[key]);

    if(
        !characValues ||
        !Array.isArray(characValues) ||
        (characValues && characValues.length <= 0)
    ){
        return null;
    }
    const dataCy = `Characteristics-Item ${props?.index !== undefined ? `Characteristics-Item-${props.index}` : ""}`;

    return (
        characValues.map((charac, index) => (
            <div
                className={`${props?.className ? props?.className : ""} main-characterisctics--row`}
                key={`main-characterisctics--${index}`}
                data-cy={dataCy}
            >
                {charac["Glyph-1"] && (
                    <div
                        className={`main-characterisctics--row--icon 
                            ${charac["Text-2"] ? "icon-padding" : "icon-padding-default"}
                            ${props.layout === "tarifas" ? "custom-min-width" : ""}`}
                    >
                        <IconGlyph
                            {...charac["Glyph-1"]}
                            dataCy={`MainCharacteristic-${index} Glyph`}
                        />
                    </div>
                )}

                <div
                    className={`main-characterisctics--row--text ${charac["Glyph-1"] ? "" : "no-glyph"
                        } ${!charac["Text-1"] ? "no-title" : ""}`}
                >
                    {charac["Text-1"] && charac["Text-1"].text && (
                        <TextInfo
                            {...charac["Text-1"]}
                            className="main-characterisctics--row--text-title"
                            cyData={`MainCharacteristic-${index} Title`}
                        />
                    )}
                    {charac["Text-2"] && (
                        <TextInfo
                            {...charac["Text-2"]}
                            className={`main-characterisctics--row--text-subtitle ${!charac["Text-1"] ? "no-mt" : ""}`}
                            cyData={`MainCharacteristic-${index} Subtitle`}
                            text={charac["Text-2"].text}
                        />
                    )}
                </div>
            </div>
        ))
    );
};

export default CharacteristicItems;